/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
// utils
import {
  Translations,
  convertStringToArrayForOption,
  convertStringToArrayForRadio,
  loadIfStateAvailableInSessionStorage
} from '../../../../utils';
// constant
// restClient
import { aemHostClient, eapiClient } from '../../../../restClient';
// children
import { blockUi, unBlockUi } from "../../../../actions/actionCreator";
import {
  ActionBar,
  CompositeList,
  CompositeListItem,
  ItemHeading,
  ListMiddleContentSection,
  ListRightContentSection
} from '../../../common/CompositeList/compositeList';
import NavListAccordion, { NavListAccordionWrapper } from '../../../common/NavListAccordion/NavListAccordion';
import IEDetailSetting from './IEDetailSetting/';
import IETireSetting from './IETireSetting';
//action Creator
import { setSowProductAllAccounts } from "../../../createASow/actions/actionCreator";
import {
  resetDeletedtTierIndex,
  setDeletedtTierIndex,
  setIETabStatus,
  setInterestEnhancementAccounts,
  setInterestEnhancementCurrency,
  setInterestEnhancementDetail,
  setPremiumMarginValue
} from './../../../CaseBody/ProductRequests/CaptureProductGlsInterestEnhancement/actions/actionCreator';
// children
//style
import './style.css';

//dummy data

/*------------IE Tire setting--------------------*/
// Add country page
//  PUT: product/gls/:glsId/account/:accountId
//  GET: product/gls/:glsId/case/:caseId/account
//  POST: product/gls/:glsId/account
//
//
// GET :product/taxonomies/cashConcentrationCountries

/*-----------End of Tier Se*/

class InterestEnhancementSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noOfReporting: 1,
      formRef: {},
      lang: '',
      glsData: {},
      dataReady: false,
      tierData: {},
      addedTiers: [],
      updatedDetailedSettings: [],
      premiumMarginVal: typeof this.props.interestEnhancement !== 'undefined' ? this.props.interestEnhancement.marginApplicable : '' || '',
      interestEnhancementTitle: typeof this.props.interestEnhancement !== 'undefined' ? this.props.interestEnhancement.interestEnhancementTitle : '' || '',
      baseCurrency: [],
      selectedCurrency: '',
      poolPositionRule: [],
      selectedPoolPositionRule: '',
      tireData: [{
        balanceForEnhancementMargin: '',
        balanceEligibleAccountsForPremiumMargin: ''
      }],
      settlementDate: {},
      tierSettingsJson: []
    };
    this.balanceTierLabels = [];
    this.payload = new payloadIE();
    this.basicDetailPayload = new payloadBasicDetail();
    this.detailSettingPayload = new payloadIeDetailSetting();
    this.tierSettingPayload = new payloadIeTierSetting();
    this.dataDictionaryURI = '';

  }
  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForOption(currentWord);
    return convertedArray;
  }

  translateWordForRadio = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForRadio(currentWord);
    return convertedArray;
  }

  loadPageState = () => {

    var { productId, caseId } = this.props.match.params;
    // this.setState({ pageJson: _pageJson }); // remove_
    // if (this.props.interestEnhancement) {
    //   this.setState({ // remove_
    //     glsData: this.props.interestEnhancement,
    //     countryList: this.props.interestEnhancement.interestEnhancement.countryAndAccount,
    //     tierData: this.props.interestEnhancement.interestEnhancement.tierSettings,
    //     dataReady: true,
    //   })
    // }
    aemHostClient("/aemData/formData/json_sow-interest-enhancement")
      .then(({ data }) => {
        this.setState({ pageJson: data.par });

        // const { caseId } = (this.props.match && this.props.match.params) || {}
        // const apiURL = `/sows/${caseId}/glses`;

        // Get Product detail
        // eapiClient(apiURL, {
        //   method: 'GET'
        // })
        //   .then(({ data }) => {
        //     // this.props.setInterestEnhancementDetail(data.responseData);
        //     // this.setState({
        //     //   glsData: data.responseData,
        //     //   countryList: data.responseData.interestEnhancement.countryAndAccount,
        //     //   tierData: data.responseData.interestEnhancement.tierSettings,
        //     //   dataReady: true,
        //     // })
        //     // this.getTaxanomyUrl();
        //   });
        if (this.props.selectedSowProduct) {
          this.props.setInterestEnhancementDetail(this.props.selectedSowProduct);
          this.setState({
            glsData: this.props.selectedSowProduct,
            countryList: this.props.selectedSowProduct.interestEnhancement.countryAndAccount,
            tierData: this.props.selectedSowProduct.interestEnhancement.tierSettings,
            dataReady: true,
          })
          // this.getTaxanomyUrl();
        }
      });

  }

  componentWillMount() {
    var { productId, caseId } = this.props.match.params;

    loadIfStateAvailableInSessionStorage(this, null, () => {
      this.loadPageState();
    });

    // eapiClient(`/product/gls/${productId}/case/${caseId}/account`)
    //   .then(({ data }) => {
    //     this.props.setInterestEnhancementAccounts(data.responseData);
    //   })
    // if (this.props.savedSow) {
    //   const apiUrl = `/sows/${this.props.savedSow && this.props.savedSow.sowId}/allAccounts`
    //   eapiClient(apiUrl).then(({ data }) => {
    //     if (Array.isArray(data.responseData) && data.responseData.length) {
    //       this.props.setInterestEnhancementAccounts(data.responseData.filter(acc => !acc.isThirdPartyAccount));
    //     }
    //     this.props.unBlockUi && this.props.unBlockUi()
    //   })
    // }

    aemHostClient("/aemData/formData/json_sow-add-country-and-accounts")
      .then(({ data }) => {
        this.setState({
          addCountryAndAccountsJson: data.par
        });
      });



    // get tab status
    this.loadTabStatus();
    this.getAllAccounts();

  }

  getAllAccounts = () => {
    this.props.blockUi && this.props.blockUi()
    const apiUrl = `/sows/${this.props.savedSow && this.props.savedSow.sowId}/allAccounts`
    eapiClient(apiUrl).then(({ data }) => {
      if (Array.isArray(data.responseData) && data.responseData.length) {
        this.setState({
          allAccounts: data.responseData.filter(acc => !acc.isThirdPartyAccount)
        })
        this.props.setSowProductAllAccounts(data.responseData.filter(acc => !acc.isThirdPartyAccount))
      }
      this.props.unBlockUi && this.props.unBlockUi()
    })
  }


  setPoolOptions = () => {
    if (this.state.tierSettingsJson !== undefined && this.state.tierSettingsJson.length !== 0) {
      let poolSideOption = this.translateWord(this.state.tierSettingsJson.guidedropdownlist_poolPositionRule.options);
      let poolOptions = poolSideOption.map(item => {
        return {
          name: item.split('=')[1],
          id: item.split('=')[0],
          lid: item.split('=')[0],
          description: item.split('=')[1],
        }
      });
      this.setState({ poolPositionRule: poolOptions })
    }
  }

  componentDidMount() {
    this.setState({
      lang: this.props.lang.currentLang.lang
    })

    var getCurrentDropDown = window.sessionStorage.getItem("getCurrentDropDown");
    var getCurrentDropDownValue = window.sessionStorage.getItem('key' + getCurrentDropDown);
    // var _eChannelReporting = this.state.reportedEChannelId;

    if (getCurrentDropDown !== null) {
      var getCurrentDropDownName = getCurrentDropDown.substring(0, getCurrentDropDown.length - 1);
    }


    window.sessionStorage.removeItem("getCurrentDropDown");
    window.sessionStorage.removeItem('key' + getCurrentDropDown);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.interestEnhancement !== nextProps.interestEnhancement) {
      this.setState({
        glsData: nextProps.interestEnhancement,
        countryList: nextProps.interestEnhancement.interestEnhancement.countryAndAccount,
        tierData: nextProps.interestEnhancement.interestEnhancement.tierSettings,
        dataReady: true,
      })
    }


  }

  // getTaxanomyUrl = () => {
  //   this.dataDictionaryURI = this.state.pageJson !== undefined && this.state.pageJson.aemform_tiersAndSettings && this.state.pageJson.aemform_tiersAndSettings.settlementDateTaxonomy ? this.translations(this.state.pageJson.aemform_tiersAndSettings.settlementDateTaxonomy) : '';
  //   this.getInterestPeriodSettlementDate()
  // }


  loadTabStatus = () => {
    let { caseId } = this.props.match.params;
    let tabStatus;

    if (this.props.history.location.state !== undefined && this.props.history.location.state.isNavigate !== undefined) {
      tabStatus = `/sows/${caseId}/InterestEnhancementStatus?isNavigate=true`;
    } else {
      tabStatus = `/sows/${caseId}/InterestEnhancementStatus`;
    }
    eapiClient(tabStatus, { method: 'GET' })
      .then(({ data }) => {
        this.props.setIETabStatus(data.responseData);
      });
  }


  onIeTierAndSettingTabDataSubmit = () => {
    let requestedObj = this.tierSettingPayload.getPayload();
    this.props.blockUi && this.props.blockUi();
    if (this.detailSettingPayload.getPayload() && this.detailSettingPayload.getPayload().interestEnhancement && this.detailSettingPayload.getPayload().interestEnhancement.detailedSettings) {
      requestedObj.interestEnhancement = {
        ...requestedObj.interestEnhancement, detailedSettings: this.detailSettingPayload.getPayload().interestEnhancement.detailedSettings.map(({ tiers, premiumMargin, country, currency, accountId }) => ({
          tiers, premiumMargin, country, currency, accountId
        }))
      }
    }

    // var { productId } = this.props.match.params;
    if (typeof requestedObj.interestEnhancementTitle !== 'undefined' ||
      typeof requestedObj.marginApplicable !== 'undefined' ||
      typeof requestedObj.interestEnhancement !== 'undefined') {
      const apiURL = `/sows/${this.props.selectedSowProduct.id}/glses`;
      // const apiURL = "/product/gls/" + productId;
      eapiClient(apiURL, {
        method: 'PUT',
        data: JSON.stringify(requestedObj)
      })
        .then(({ data }) => {
          this.props.setInterestEnhancementDetail(data.responseData);
          this.loadTabStatus();
          this.props.unBlockUi && this.props.unBlockUi();
        });
    }
  }

  onIeDetailSettingTabDataSubmit = () => {
    let requestedObj = this.detailSettingPayload.getPayload();
    var { productId } = this.props.match.params;
    if (typeof requestedObj.interestEnhancementTitle !== 'undefined' ||
      typeof requestedObj.marginApplicable !== 'undefined' ||
      typeof requestedObj.interestEnhancement !== 'undefined') {
      const apiURL = `/sows/${this.props.selectedSowProduct.id}/glses`;
      // const apiURL = "/product/gls/" + productId;
      eapiClient(apiURL, {
        method: 'PUT',
        data: JSON.stringify(requestedObj)
      })
        .then(({ data }) => {
          this.props.setInterestEnhancementDetail(data.responseData);
          this.loadTabStatus();
        });
    }
  }

  submitForm = () => {
    let requestedObj = this.payload.getPayload();
    var { productId } = this.props.match.params;
    if (typeof requestedObj.interestEnhancementTitle !== 'undefined' ||
      typeof requestedObj.marginApplicable !== 'undefined' ||
      typeof requestedObj.interestEnhancement !== 'undefined') {
      const apiURL = `/sows/${this.props.selectedSowProduct.id}/glses`;
      // const apiURL = "/product/gls/" + productId;
      eapiClient(apiURL, {
        method: 'PUT',
        data: JSON.stringify(requestedObj)
      })
        .then(({ data }) => {
          this.props.setInterestEnhancementDetail(data.responseData);
          this.setState({
            glsData: data.responseData,
            countryList: data.responseData.interestEnhancement.countryAndAccount,
            tierData: data.responseData.interestEnhancement.tierSettings,
            dataReady: true
          });
          this.props.history.push('/sow-body');
        });
    } else {
      ///this.props.history.push('/sow-body');
    }
  }

  validateIETierSettings = (tierSettings = [], detailedSettings = []) => {

  }

  // Delete composit list country
  deleteCountry = (item) => {
    let deleteGroup = '/sows/interest-enhancements/' + this.props.selectedSowProduct.id + '/cancelSowCountryGroup/' + item.id;
    eapiClient(deleteGroup,
      {
        method: 'DELETE'
      })
      .then(({ data }) => {
        this.props.setInterestEnhancementDetail(data.responseData);
        var displayCountry = data.responseData.interestEnhancement.countryAndAccount && data.responseData.interestEnhancement.countryAndAccount.filter(item => {
          var str = item.status.includes('delete')
          if (str) {
            return false
          } else {
            return item
          }
        })

        this.setState({
          countryList: displayCountry,
          updatedDetailedSettings: data.responseData.interestEnhancement.detailedSettings
        })
        // get tab status

        // get tab status
        this.loadTabStatus();

      })

  }
  goToFormEdit = (event, id, lid) => {
    var { caseId, productId } = this.props.match.params;
    if (id !== 'undefined' && lid !== 'undefined') {
      let editPath = '/sow-body/capture-product-interest-enhancement/add-country-and-account/' + caseId + '/' + productId;
      this.props.history.push({
        pathname: editPath,
        state: {
          id: id,
          lid: lid,
          mode: 'edit'
        }
      });
    }
  }
  getIETierAndSettingData = (data) => {
    var localObj = {
      name: 'IEDetailSetting',
      value: data
    }
    this.payload.setPayload(localObj);
    this.detailSettingPayload.setPayload(localObj);
  }

  IETireSettingData = (data) => {
    let tet = {};
    let resetTier = []
    if (data.interestEnhancement.tierSettings && data.interestEnhancement.tierSettings.tiers !== undefined) {
      data.interestEnhancement.tierSettings.tiers.map(item => {
        tet.balanceForEnhancementMargin = ''
        tet.balanceEligibleAccountsForPremiumMargin = ''
        tet.tierId = null
        resetTier.push(tet);
      })
      this.setState({
        addedTiers: resetTier
      })
    }
    var localObj = {
      name: 'IETireSetting',
      value: data.interestEnhancement
    }
    this.payload.setPayload(localObj);
    this.tierSettingPayload.setPayload(localObj);
  }

  resetDeletedIndex = () => {
    this.props.resetDeletedtTierIndex()
  }

  countryName = (name) => {
    let countryArray = name.split(':')
    let valLen = countryArray.length;
    let countryName = countryArray[valLen - 2]

    return countryName.replace(/([a-z](?=[A-Z]))/g, '$1 ');
  }

  render() {
    if (typeof this.props.interestEnhancement !== 'undefined' && this.state.addCountryAndAccountsJson !== undefined && this.state.pageJson !== undefined) {
      var { caseId, productId } = this.props.match.params;
      const { refrenceId, glsAgent, interestEnhancementTitle, interestEnhancement } = this.props.interestEnhancement;
      this.dataDictionaryURI = this.state.pageJson !== undefined && this.state.pageJson.aemform_tiersAndSettings && this.state.pageJson.aemform_tiersAndSettings.settlementDateTaxonomy ? this.translations(this.state.pageJson.aemform_tiersAndSettings.settlementDateTaxonomy) : '';

      document.title = (refrenceId && this.state.pageJson !== undefined)
        ? `${"Product Requests"} - ${"Review Product"} - ${this.translations(this.state.pageJson.page_title_mainTitle.pageHeading)} ${refrenceId} - ${'HSBC GLCM'}`
        : `${"Product Requests"}- ${'HSBC GLCM'}`;

      return (
        <div className="customer-details-container">
          <div className="pannel-heading-container">
            <div><h2 className="pannel-heading">{this.translations(this.state.pageJson.page_title_mainTitle.pageHeading)} <span>({refrenceId})</span></h2></div>
            <p className="pannel-sub-heading">{`${this.translations(this.state.pageJson.page_title_mainTitle.agent)}: ${typeof glsAgent.name !== 'undefined' ? glsAgent.name : ''}`} {interestEnhancementTitle !== undefined && interestEnhancementTitle.length > 0 ? `(${interestEnhancementTitle})` : ''}</p>
            <p className="optional-text"><b>{this.translations(this.state.pageJson.page_title_mainTitle.descriptionText)}</b></p>
          </div>

          <div className="gdocs-clear-float"></div>
          <NavListAccordionWrapper>
            <NavListAccordion
              lang={this.props.lang.currentLang.lang}
              navAccHeading={`1. ${this.translations(this.state.pageJson.aemform_countriesAccounts.title)}`}
              status={this.props.tabStatus !== undefined ? this.props.tabStatus.countriesAndAccounts.status : ''}
            >
              <div className="addresses-section">
                <div className="gdocs-mtop-20">
                  <CompositeList>
                    {
                      this.state.countryList !== undefined
                        ? this.state.countryList.map((item, key) => {
                          var accountCount = item.accounts.length;
                          var premiumCount = item.accounts.filter(key => key.premiumMargin).length;
                          return (
                            <CompositeListItem key={key}>
                              <ListRightContentSection>
                                <ItemHeading lid={item.lid} id={item.id} _onClick={this.goToFormEdit} showArrowIcon={false}><a >{item.country.name}</a></ItemHeading>
                              </ListRightContentSection>
                              <ListMiddleContentSection>
                                <span>{`${accountCount} ${this.translations(this.state.addCountryAndAccountsJson.static_text_addCountry.accounts)} (${premiumCount} ${this.translations(this.state.addCountryAndAccountsJson.static_text_addCountry.premium)})`}</span>
                              </ListMiddleContentSection>
                              {
                                !this.props.customer.roleDetails.customer
                                  ? <ActionBar _onClick={this.deleteCountry.bind(this, item)} />
                                  : ''
                              }
                            </CompositeListItem>)
                        })
                        : ''
                    }
                  </CompositeList>
                  <div className="gdocs-mtop-10 gdocs-mbottom-10">
                    <Link
                      className={`add-county-btn ${this.props.customer.roleDetails.customer ? 'disabled' : ''}`}
                      to={'/sow-body/capture-product-interest-enhancement/add-country-and-account/' + caseId + '/' + productId}
                    >
                      <i className="icon icon-add"></i>{this.translations(this.state.addCountryAndAccountsJson.static_text_addCountry.addCountryBtnText)}
                    </Link>
                  </div>
                </div>
              </div>
            </NavListAccordion>
            <NavListAccordion
              lang={this.props.lang.currentLang.lang}
              navAccHeading={`2. ${this.translations(this.state.pageJson.aemform_tiersAndSettings.title)}`}
              status={this.props.tabStatus !== undefined ? this.props.tabStatus.tierSettings.status : ''}
            >
              <div className="addresses-section">
                <div>
                  <IETireSetting
                    IETireSettingData={this.IETireSettingData}
                    {...this.props.interestEnhancement}
                    premiumMargin={this.state.premiumMarginVal}
                    lang={this.props.lang}
                    ieTireSettingTabData={this.onIeTierAndSettingTabDataSubmit}
                    dataDictionaryURI={this.dataDictionaryURI}
                  />
                </div>
              </div>
            </NavListAccordion>


            {
              this.state.countryList !== undefined && this.state.countryList.length > 0 &&
              <NavListAccordion
                lang={this.props.lang.currentLang.lang}
                navAccHeading={`3. ${this.translations(this.state.pageJson.aemform_detailedSettings.title)}`}
                status={this.props.tabStatus !== undefined ? this.props.tabStatus.detailedSettings.status : ''}
              >
                <div className="addresses-section">
                  <div>
                    <IEDetailSetting
                      getIETierAndSettingData={this.getIETierAndSettingData}
                      {...this.props.interestEnhancement}
                      newTiers={this.state.addedTiers}
                      deletedIndex={this.props.deletedIndex}
                      _resetDeletedIndex={this.resetDeletedIndex}
                      premiumMargin={this.state.premiumMarginVal}
                      disabled={this.props.customer.roleDetails.customer}
                      updatedDetail={this.state.updatedDetailedSettings}
                      lang={this.props.lang}
                      ieDetailSettingTabData={this.onIeDetailSettingTabDataSubmit}
                      accounts={this.props.accounts}
                      oldTiers={this.props.interestEnhancement.interestEnhancement.tierSettings}
                      history={this.props.history}
                      selectedSowProduct={this.props.selectedSowProduct}
                    />
                  </div>
                </div>
              </NavListAccordion>
            }
          </NavListAccordionWrapper>
          <div className="save-btn-right">
            <button onClick={this.submitForm} className='btn save-btn'>{this.translations(this.state.pageJson.button_saveAndReturn.text)}</button>
          </div>
        </div>)
    } else {
      return (<div></div>);
    }
  }
}

// Basic Detail Payload
class payloadBasicDetail {
  constructor(props) {
    this.data = {};
    this.data.interestEnhancement = {}
  }

  setPayload(data) {
    switch (data.name) {
      case "basicDetails":
        const { interestEnhancementTitle, marginApplicable, id, lid, glsAgent, relationshipBank } = data.value;
        this.data.interestEnhancementTitle = interestEnhancementTitle;
        this.data.marginApplicable = marginApplicable;
        this.data.glsAgent = glsAgent;
        this.data.relationshipBank = relationshipBank;
        this.data.id = id;
        this.data.lid = lid;
        break;
      default:
    }
  }
  getPayload() {
    if ('interestEnhancement' in this.data) {
      return this.data;
    } else {
      return {
        ...this.data,
        interestEnhancement: {}
      }
    }
  }
}

// Tier setting payload
class payloadIeTierSetting {
  constructor(props) {
    this.data = {};
    this.data.interestEnhancement = {};
  }

  setPayload(data) {
    switch (data.name) {
      case "IETireSetting":
        this.data.interestEnhancement.tierSettings = data.value.tierSettings;
        break;
      default:
    }
  }

  getPayload() {
    if ('interestEnhancement' in this.data) {
      return this.data;
    } else {
      return {
        ...this.data,
        interestEnhancement: {}
      }
    }
  }
}

// Detail setting payload
class payloadIeDetailSetting {
  constructor(props) {
    this.data = {};
    this.data.interestEnhancement = {};
  }

  setPayload(data) {
    switch (data.name) {
      case "IEDetailSetting":
        this.data.interestEnhancement.detailedSettings = data.value.map(item => {
          if (item.interestContribution === undefined) {
            item.interestContribution = {
              name: "Interest Contribution",
              value: "Interest Contribution"
            }
          }
          return item;
        })
        break;
      default:
    }
  }

  getPayload() {
    if ('interestEnhancement' in this.data) {
      return this.data;
    } else {
      return {
        ...this.data,
        interestEnhancement: {}
      }
    }
  }
}

// E-Channel Reporting Section Payload
// class EchannelReportingSection {
//   constructor() {
//     this.data = {}
//     this.data.interestEnhancement = {};
//   }

//   setEchannelReporting({ reportedEChannelId, eChannelReported }) {
//     this.data.interestEnhancement.reportedEChannelId = reportedEChannelId;
//     this.data.interestEnhancement.eChannelReported = eChannelReported;
//   }

//   getPayload() {
//     if ('interestEnhancement' in this.data) {
//       return this.data;
//     } else {
//       return {
//         ...this.data,
//         interestEnhancement: {}
//       }
//     }
//   }
// }

class payloadIE {
  constructor(props) {
    this.data = {};
    this.data.interestEnhancement = {};
  }

  setPayload(data) {
    switch (data.name) {
      case "basicDetails":
        const { interestEnhancementTitle, marginApplicable, id, lid, glsAgent, relationshipBank } = data.value;
        this.data.interestEnhancementTitle = interestEnhancementTitle;
        this.data.marginApplicable = marginApplicable;
        this.data.glsAgent = glsAgent;
        this.data.relationshipBank = relationshipBank;
        this.data.id = id;
        this.data.lid = lid;
        break;
      case "IETireSetting":
        this.data.interestEnhancement.tierSettings = data.value.tierSettings;
        break;
      case "IEDetailSetting":
        this.data.interestEnhancement.detailedSettings = data.value.map(item => {
          if (item.interestContribution === undefined) {
            item.interestContribution = {
              name: "Interest Contribution",
              value: "Interest Contribution"
            }
          }
          return item;
        })
        break;
      // case 'EChannelReporting':
      //   const { eChannelReported, reportedEChannelId } = data.value
      //   this.data.interestEnhancement.eChannelReported = eChannelReported;
      //   this.data.interestEnhancement.reportedEChannelId = reportedEChannelId;
      //   break;
      default:

    }
  }
  getPayload() {
    if ('interestEnhancement' in this.data) {
      return this.data;
    } else {
      return {
        ...this.data,
        interestEnhancement: {}
      }
    }
  }
}

const mapStateToProps = state => {
  let poolAccounts = []
  const { location = {}, notionalPooling = {} } = (state.sowEntities && state.sowEntities.selectedSowProduct) || {}
  if (state.sowEntities.allAccounts) {
    poolAccounts = state.sowEntities.allAccounts
  }
  return {
    tabStatus: state.currentProductInterestEnhancement.ieTabStatus,
    // CurrentProductEchannel: state.CurrentProductEchannel,
    entities: state.entities,
    customer: state.auth.userDetails,
    interestEnhancement: state.currentProductInterestEnhancement.data,
    // interestEnhancement: _interestEnhancement,
    // accounts: state.currentProductInterestEnhancement.accounts,
    accounts: poolAccounts,
    lang: state.lang,
    deletedIndex: state.currentProductInterestEnhancement.deletedIndex,
    countries: state.currentProductInterestEnhancement.countries,
    data: state.currentProductInterestEnhancement.data,
    // data: _interestEnhancement,
    savedSow: (state.sowEntities && state.sowEntities.savedSow) || {},
    selectedSowProduct: (state.sowEntities && state.sowEntities.selectedSowProduct) || {},
  }
}

const mapDispatchToProps = dispatch => {
  return {
    // setCurrentProductEchannel: productsechanneldata => {
    //   dispatch(setCurrentProductEchannel(productsechanneldata))
    // },
    setInterestEnhancementDetail: data => {
      dispatch(setInterestEnhancementDetail(data))
    },
    setPremiumMarginValue: val => {
      dispatch(setPremiumMarginValue(val))
    },
    setIETabStatus: data => {
      dispatch(setIETabStatus(data))
    },
    setInterestEnhancementAccounts: accounts => {
      dispatch(setInterestEnhancementAccounts(accounts));
    },
    resetDeletedtTierIndex: () => {
      dispatch(resetDeletedtTierIndex())
    },
    setInterestEnhancementCurrency: currencies => {
      dispatch(setInterestEnhancementCurrency(currencies));
    },
    setDeletedtTierIndex: deletedIndex => {
      dispatch(setDeletedtTierIndex(deletedIndex));
    },
    setSowProductAllAccounts: accounts => {
      dispatch(setSowProductAllAccounts(accounts))
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InterestEnhancementSummary);



// WEBPACK FOOTER //
// ./src/components/SowBody/GLSProduct/InterestEnhancementSummary/index.js